const isMobile = cc.sys.isMobile;
// const isMobile = true;//testing

const isIOS14Device =
 // check if iphone ios 14
 cc.sys.os === cc.sys.OS_IOS && cc.sys.isBrowser && cc.sys.isMobile && /iPhone OS 14/.test(window.navigator.userAgent) ||
 // running on macos
 cc.sys.os === cc.sys.OS_OSX ||
 // running ios 14 on ipad
 cc.sys.os === cc.sys.OS_IOS && cc.sys.isBrowser && !cc.sys.isMobile && /Intel Mac OS X 10_15/.test(window.navigator.userAgent)
 && window.navigator.maxTouchPoints && window.navigator.maxTouchPoints > 1;

const isChrome = navigator.userAgent.match('CriOS')
const isIosChrome = isIOS14Device && isChrome;

export default {
    get isMobile () { return isMobile },
    get isIosChrome () { return isIosChrome }
}

